import { taggedTemplateLiteral as _taggedTemplateLiteral, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { gql } from '@apollo/client';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var queryPendingTests = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query PendingTests($giid: String!) {\n    installation(giid: $giid) {\n      testsPending {\n        deviceLabel\n        testType\n        reason\n        requestTime\n      }\n    }\n  }\n"])));
var testNeededAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(client, giid) {
    var result, testsPending;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.query({
              query: queryPendingTests,
              variables: {
                giid: giid
              }
            });
          case 3:
            result = _context.sent;
            testsPending = result.data.installation.testsPending;
            return _context.abrupt("return", testsPending);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            if (_context.t0.networkError) {
              _context.next = 12;
              break;
            }
            throw _context.t0;
          case 12:
            return _context.abrupt("return", null);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function testNeededAsync(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// TODO implement in GraphQL when we have the permissions to call the API
var queryVoiceCallAllowed = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query VoiceCallAllowed($giid: String!) {\n    installation(giid: $giid) {\n      voiceCallAllowed {\n        allowed\n        errorMessage\n        voipAvailable\n        gsmVoiceAvailable\n      }\n    }\n  }\n"])));
var allowedToDoVoiceTestAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(client, giid) {
    var result, voiceCallAllowed;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return client.query({
              query: queryVoiceCallAllowed,
              variables: {
                giid: giid
              }
            });
          case 3:
            result = _context2.sent;
            voiceCallAllowed = result.data.installation.voiceCallAllowed;
            return _context2.abrupt("return", voiceCallAllowed);
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            if (_context2.t0.networkError) {
              _context2.next = 12;
              break;
            }
            throw _context2.t0;
          case 12:
            return _context2.abrupt("return", null);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return function allowedToDoVoiceTestAsync(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

// TODO implement in GraphQL when we have the permissions to call the API
var mutateVoiceAutoTest = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  mutation TriggerAutoVoiceSession($giid: String!, $deviceLabel: String!, $networkType: String!) {\n    TriggerAutoVoiceSession(giid: $giid, deviceLabel: $deviceLabel, networkType: $networkType)\n  }\n"])));
var initiateVoiceTestAsync = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(client, giid, deviceLabel, networkType) {
    var result, TriggerAutoVoiceSession;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return client.mutate({
              mutation: mutateVoiceAutoTest,
              variables: {
                giid: giid,
                deviceLabel: deviceLabel,
                networkType: networkType
              }
            });
          case 3:
            result = _context3.sent;
            TriggerAutoVoiceSession = result.data.TriggerAutoVoiceSession;
            return _context3.abrupt("return", TriggerAutoVoiceSession);
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            if (_context3.t0.networkError) {
              _context3.next = 12;
              break;
            }
            throw _context3.t0;
          case 12:
            return _context3.abrupt("return", null);
          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));
  return function initiateVoiceTestAsync(_x5, _x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
var queryGetTestResult = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  query VoiceTest($giid: String!, $sessionId: String!) {\n    installation(giid: $giid) {\n      autoVoiceTest(sessionId: $sessionId) {\n        networkType\n        type\n        state\n        sessionId\n        changedTime\n      }\n    }\n  }\n"])));
var getTestStatusAsync = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(client, giid, sessionId) {
    var result, autoVoiceTest;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return client.query({
              query: queryGetTestResult,
              variables: {
                giid: giid,
                sessionId: sessionId
              }
            });
          case 3:
            result = _context4.sent;
            autoVoiceTest = result.data.installation.autoVoiceTest;
            return _context4.abrupt("return", autoVoiceTest);
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            if (_context4.t0.networkError) {
              _context4.next = 12;
              break;
            }
            throw _context4.t0;
          case 12:
            return _context4.abrupt("return", null);
          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));
  return function getTestStatusAsync(_x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();

export { allowedToDoVoiceTestAsync, getTestStatusAsync, initiateVoiceTestAsync, mutateVoiceAutoTest, queryGetTestResult, queryPendingTests, queryVoiceCallAllowed, testNeededAsync };
